<template>
  <form @submit.prevent="$emit('submit')" novalidate="true" autocomplete="off">
    <form-field
      full-width
      required
      label="Tag Name"
      name="tag_name"
      :max-length="45"
      show-counter
      helper-text="Please enter the tag (45 characters max)"
      v-validate="'required|min:2'"
      data-vv-as="tag name"
      :error="errors.first('tag_name')"
      v-model="tag.name"
    ></form-field>
  </form>
</template>

<script>

export default {
  name: 'category-form',

  computed: {
    tag: {
      get() {
        return this.$store.state.tags.currentTag;
      },
      set(value) {
        this.$store.commit('tags/setCurrentTag', value);
      },
    },
  },
};
</script>
